<!-- ── Page header ────────────────────────────────────────────────────────────── -->
<section class="tg-page-hero">
  <div class="tg-container">
    <h1 class="tg-page-hero__title">Vacantes de Tecnología</h1>
    <p class="tg-page-hero__sub">Encuentra tu próxima oportunidad entre cientos de posiciones tech</p>
    <ul class="tg-page-hero__breadcrumb">
      <li><a routerLink="/">Inicio</a></li>
      <li>›</li>
      <li>Vacantes</li>
    </ul>
  </div>
</section>

<!-- ── Categorías rápidas (mismas que en inicio, fijas aquí para no tener que regresar) ── -->
<section style="background:#f0f4ff;padding:16px 0;">
  <div class="tg-container">
    <div class="tw-flex tw-flex-wrap tw-gap-2 tw-justify-center" *ngIf="categorias?.length">
      <a *ngFor="let cat of categorias"
         (click)="seleccionarCategoria(cat.idCategoria)"
         [class.tw-bg-blue-600]="categoriaSeleccionada === cat.idCategoria"
         [class.tw-text-white]="categoriaSeleccionada === cat.idCategoria"
         [class.tw-bg-white]="categoriaSeleccionada !== cat.idCategoria"
         [class.tw-text-slate-700]="categoriaSeleccionada !== cat.idCategoria"
         class="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-full tw-text-xs tw-font-semibold tw-cursor-pointer tw-transition tw-border tw-border-slate-200"
         style="text-decoration:none;">
        <img *ngIf="cat.icono" [src]="cat.icono" [alt]="cat.nombreCategoria" style="width:14px;height:14px;object-fit:cover;border-radius:3px;">
        {{cat.nombreCategoria}}
      </a>
    </div>
  </div>
</section>

<!-- ── Filter bar (sticky para poder seguir ajustando filtros con el scroll) ────── -->
<div class="filter-bar">
  <div class="tg-container">
    <form [formGroup]="formFilter" (ngSubmit)="buscador()" class="filter-form">
      <div class="field-wrap--wide">
        <input type="text" id="tituloVacante" name="tituloVacante"
               formControlName="tituloVacante"
               placeholder="Vacante, cargo o puesto"
               style="width:100%;border:1px solid #e5e7eb;border-radius:8px;padding:10px 14px;font-size:14px;background:#f9fafb;min-height:auto;color:#111827;">
      </div>
      <div class="field-wrap">
        <select id="pais" name="pais" formControlName="pais"
                style="width:100%;border:1px solid #e5e7eb;border-radius:8px;padding:10px 14px;font-size:14px;background:#f9fafb;min-height:auto;color:#111827;cursor:pointer;">
          <option [ngValue]="null">País</option>
          <option *ngFor="let p of paises" [ngValue]="p">{{ p }}</option>
        </select>
      </div>
      <div class="field-wrap"><select id="categoria" name="categoria" formControlName="categoria"
                style="width:100%;border:1px solid #e5e7eb;border-radius:8px;padding:10px 14px;font-size:14px;background:#f9fafb;min-height:auto;color:#111827;cursor:pointer;">
          <option [ngValue]="0">Categorías</option>
          <option *ngFor="let categoria of categorias" [ngValue]="categoria.idCategoria">
            {{categoria.nombreCategoria}}
          </option>
        </select>
      </div>
      <div class="field-wrap">
        <select id="tipoContrato" name="tipoContrato" formControlName="tipoContrato"
                style="width:100%;border:1px solid #e5e7eb;border-radius:8px;padding:10px 14px;font-size:14px;background:#f9fafb;min-height:auto;color:#111827;cursor:pointer;">
          <option [ngValue]="null">Tipo de contrato</option>
          <option *ngFor="let t of tiposContrato" [ngValue]="t">{{ t }}</option>
        </select>
      </div>
      <div class="field-wrap">
        <select id="idModalidadEmpleo" name="idModalidadEmpleo" formControlName="idModalidadEmpleo"
                style="width:100%;border:1px solid #e5e7eb;border-radius:8px;padding:10px 14px;font-size:14px;background:#f9fafb;min-height:auto;color:#111827;cursor:pointer;">
          <option [ngValue]="0">Modalidad</option>
          <option *ngFor="let m of modalidadesEmpleo" [ngValue]="m.idmodalidadempleo">{{ m.nombre }}</option>
        </select>
      </div>
      <div class="btn-responsive">
        <button type="submit" class="tg-btn tg-btn--primary" [disabled]="cargando"
                style="height:42px;white-space:nowrap;">
          <app-loading-spinner *ngIf="cargando" [inline]="true" [size]="14" [light]="true"></app-loading-spinner>
          <svg *ngIf="!cargando" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
               style="width:15px;height:15px;margin-right:6px;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 15.803 7.5 7.5 0 0 0 15.803 15.803z"/>
          </svg>
          {{ cargando ? 'Buscando…' : 'Buscar' }}
        </button>
      </div>
      <div class="btn-responsive" *ngIf="hayFiltrosActivos">
        <button type="button" class="tg-btn tg-btn--ghost" (click)="limpiarFiltros()" style="height:42px;white-space:nowrap;">
          Limpiar filtros
        </button>
      </div>
    </form>
    <!-- Mensaje de error minimalista -->
    <div *ngIf="mensajeError" class="tw-flex tw-items-start tw-gap-2.5 tw-p-3 tw-mt-3 tw-rounded-xl tw-border tw-border-amber-200"
         style="background:#fffbeb;">
      <svg class="tw-w-5 tw-h-5 tw-flex-shrink-0 tw-mt-0.5" style="color:#d97706;" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"/>
      </svg>
      <p class="tw-text-sm tw-text-amber-800 tw-m-0">{{ mensajeError }}</p>
    </div>
  </div>
</div>

<!-- ── Job cards ──────────────────────────────────────────────────────────────── -->
<section style="background:#f9fafb;padding:36px 0 64px;" #listaVacantes>
  <div class="tg-container">

    <!-- Skeleton loading estilo Skyscanner (en vez de spinner de página completa) -->
    <div *ngIf="cargando" class="tw-grid tw-gap-5" style="grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));">
      <div *ngFor="let i of [1,2,3,4,5,6]" class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-5" style="box-shadow:0 1px 3px rgba(0,0,0,.06);">
        <div class="tg-skeleton-line" style="width:70%;height:12px;margin-bottom:10px;"></div>
        <div class="tg-skeleton-line" style="width:100%;height:16px;margin-bottom:14px;"></div>
        <div class="tg-skeleton-line" style="width:50%;height:12px;margin-bottom:8px;"></div>
        <div class="tg-skeleton-line" style="width:90%;height:12px;margin-bottom:8px;"></div>
        <div class="tg-skeleton-line" style="width:40%;height:32px;margin-top:16px;"></div>
      </div>
    </div>

    <ng-container *ngIf="!cargando">
    <div class="tw-grid tw-gap-5" style="grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));">
    <div *ngFor="let vacante of vacantes"
         class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-5 tw-flex tw-flex-col tw-gap-3"
         style="box-shadow: 0 1px 3px rgba(0,0,0,.08); transition: box-shadow .2s">
      <div class="tw-flex tw-items-start tw-gap-3">
        <div class="tw-w-10 tw-h-10 tw-rounded-xl tw-bg-slate-100 tw-flex-shrink-0 tw-overflow-hidden">
          <img [src]="vacante.logo" [alt]="vacante.nombreEmpresa" [title]="vacante.nombreEmpresa"
               loading="lazy" class="tw-w-full tw-h-full tw-object-cover"
               (error)="onImageError($event)">
        </div>
        <div class="tw-flex-1 tw-min-w-0">
          <p class="tw-text-xs tw-text-slate-400 tw-truncate">{{vacante.nombreEmpresa}}</p>
          <h3 class="tw-text-sm tw-font-semibold tw-text-slate-800 tw-leading-snug">
            <a (click)="verDetalles(vacante)" style="cursor:pointer;color:inherit;text-decoration:none;">{{ vacante.nombre }}</a>
          </h3>
          <a *ngIf="vacante.urlPaginaWeb" (click)="redirigirUrl(vacante.urlPaginaWeb)"
             class="tw-text-xs tw-truncate tw-block" style="color:#0066ff;cursor:pointer;">
            {{ vacante.urlPaginaWeb }}
          </a>
        </div>
        <span *ngIf="vacante.etiqueta"
              class="tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium tw-flex-shrink-0"
              style="background:#eff6ff; color:#0066ff">
          {{vacante.etiqueta}}
        </span>
      </div>

      <div class="tw-flex tw-flex-wrap tw-gap-1.5">
        <span *ngIf="vacante.tipoContrato" class="tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-slate-100 tw-text-slate-600 tw-text-xs">{{vacante.tipoContrato}}</span>
        <span *ngIf="$any(vacante).modalidadEmpleo" class="tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-slate-100 tw-text-slate-600 tw-text-xs">{{$any(vacante).modalidadEmpleo}}</span>
        <span *ngIf="vacante.salarioMin > 0 && vacante.salarioMax > 0"
              class="tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium" style="background:#ecfdf5; color:#065f46">
          ${{ vacante.salarioMin | number: '0.00' }} – ${{ vacante.salarioMax | number: '0.00' }}
        </span>
      </div>

      <p *ngIf="vacante.direccion" class="tw-text-xs tw-text-slate-400">📍 {{vacante.direccion}}</p>

      <p class="tw-text-xs tw-text-slate-500 tw-flex-1" *ngIf="vacante.descripcion"
         style="display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden">
        {{ snippetText(vacante.descripcion) }}…
      </p>

      <p *ngIf="vacante.fechaCreado" class="tw-text-xs tw-text-slate-400">
        Publicado: {{ vacante.fechaCreado | appDate:'dd/MM/yyyy' }}
      </p>

      <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-mt-auto">
        <div class="tw-flex tw-flex-wrap tw-gap-1.5">
          <button *ngIf="usuarioRol == 'empresa'" type="button" class="tg-btn tg-btn--ghost tg-btn--sm" (click)="editarVacante(vacante.idVacante)">Editar</button>
          <button *ngIf="usuarioRol == 'empresa'" type="button" class="tg-btn tg-btn--ghost tg-btn--sm" (click)="duplicarVacante(vacante.idVacante)" [disabled]="duplicando">Duplicar</button>
          <button *ngIf="usuarioRol == 'empresa' && !vacante.status" type="button" class="tg-btn tg-btn--ghost tg-btn--sm" (click)="editarStatusVacante(vacante.idVacante, true)">Habilitar</button>
          <button *ngIf="usuarioRol == 'empresa' && vacante.status" type="button" class="tg-btn tg-btn--ghost tg-btn--sm" (click)="editarStatusVacante(vacante.idVacante, false)">Deshabilitar</button>
        </div>
        <a *ngIf="!usuarioRol || usuarioRol == 'candidato'" (click)="verDetalles(vacante)"
           class="tw-py-2 tw-px-4 tw-rounded-xl tw-text-white tw-text-xs tw-font-semibold tw-text-center tw-transition tw-cursor-pointer tw-flex-shrink-0"
           style="background:#0066ff; text-decoration:none">
          Ver detalles
        </a>
      </div>
    </div>

    </div>

    <!-- Empty state minimalista -->
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-4 tw-py-16 tw-text-center" *ngIf="vacantes?.length === 0">
      <div class="tw-w-14 tw-h-14 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-mb-4" style="background:#f0f4ff;">
        <svg class="tw-w-7 tw-h-7" style="color:#6366f1;" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 15.803a7.5 7.5 0 0 0 10.607 10.607Z"/>
        </svg>
      </div>
      <h3 class="tw-text-base tw-font-semibold tw-text-slate-700 tw-mb-1">Sin resultados</h3>
      <p class="tw-text-sm tw-text-slate-400 tw-max-w-xs tw-m-0">No encontramos vacantes con esos criterios. Intenta ajustando los filtros.</p>
    </div>

    <!-- Pagination -->
    <div class="d-flex justify-content-center mt-3" *ngIf="totalItems > cantidadVacantes">
      <pagination-controls class="page-numbers"
        (pageChange)="onPageChange($event)"
        (click)="scrollToElement(listaVacantes)"
        [responsive]="true"
        [previousLabel]="''"
        [nextLabel]="''">
      </pagination-controls>
    </div>

    <!-- Contador de resultados visibles -->
    <p class="text-center tw-mt-2 tw-text-sm" style="color:#6b7280;" *ngIf="totalItems > 0">
      Mostrando
      <strong>{{ (noPagina - 1) * cantidadVacantes + 1 | number }}</strong>
      al
      <strong>{{ noPagina * cantidadVacantes > totalItems ? (totalItems | number) : (noPagina * cantidadVacantes | number) }}</strong>
      de
      <strong>{{ totalItems | number }}</strong>
      vacantes
    </p>
    </ng-container>

  </div>
</section>

<!-- pipe oculto que solo existe para alimentar a ngx-pagination con el total real del servidor -->
<div style="display:none" *ngIf="[] | paginate: { itemsPerPage: cantidadVacantes, currentPage: noPagina, totalItems: totalItems }"></div>
